import {MxSelector, MxSelectorCreator} from '../store.types';
import {createSelector} from '@ngrx/store';
import {DisabledSelectOptions} from '@aviary/store/common/common.types';

export const alwaysTrue: MxSelector<boolean> = createSelector(
  () => true
);

export const alwaysFalse: MxSelector<boolean> = createSelector(
  () => false
);

export const alwaysEmptyString: MxSelector<string> = createSelector(
  () => ''
);

export const alwaysEmptyStringFor: MxSelectorCreator<[object], string> =
  () => alwaysEmptyString;

export const alwaysEmptyObject: MxSelector<object> = createSelector(
  () => ({})
);

export const alwaysEmptyStringArray: MxSelector<string[]> = createSelector(
  () => [] as string[]
);

export const alwaysEmptyDisabledSelectOptions: MxSelector<DisabledSelectOptions> = createSelector(
  () => [] as DisabledSelectOptions
);
